// export const environment = {
//   production: true,
//   baseUrl: `${window.location.origin}/api`,
//   redirectUrl: 'https://test-entregis.set.or.th/login/admin',
//   tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
//   clientId: '07e996e4-9a5f-408f-9f32-43475f33e813',
//   setLink: 'https://train.setlink.set.or.th/  '
// };
export const environment = {
  production: true,
  baseUrl: `${window.location.origin}/api`,
  redirectUrl: 'https://test-corporate-access.setstage.or.th/login/admin',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: '07e996e4-9a5f-408f-9f32-43475f33e813',
  setLink: 'https://train.setlink.set.or.th/  '
};